'use strict';

(function (angular) {
  angular.module('zp').service('SearchService', searchService);

  /**ngInject */
  function searchService($q, zpAPI, SearchModel, $http) {

    var service = this;
    var searchModel = null;

    service.getSearchModel = getSearchModel;
    service.getHoneyMoons = getHoneyMoons;
    service.getCities = getCities;

    /////////////////////////////////////////

    function getSearchModel() {
      return $q.when(function () {
        if (!searchModel) {
          searchModel = new SearchModel();
          searchModel.city = null;
          searchModel.latitude = null;
          searchModel.longitude = null;
        }
        return searchModel;
      }());
    }

    function getHoneyMoons() {
      return zpAPI.http({
        method: 'GET',
        url: '/destinations'
      });
    }

    function getHoneyMoon(destinationId) {
      return zpAPI.http({
        method: 'GET',
        url: '/destinations/' + destinationId
      });
    }

    function getCities() {
      return zpAPI.http({
        method: 'GET',
        url: '/cities'
      });
    }
  }
})(window.angular);